import { React, useState } from 'react';

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import RuleRoundedIcon from '@mui/icons-material/RuleRounded';
import ShowChartRoundedIcon from '@mui/icons-material/ShowChartRounded';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { pt } from 'date-fns/locale';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { downloadCsvContent } from '../../utils/csvExport';
import { formatMonthYearLabelPtBr, formatShortMonthParam } from '../../utils/dateUtils';
import { fetchFlask } from '../../utils/fetchFlask';
import '../css/generatorSurplus.css';

const ExcedentesUG = () => {
    const [dateTimePeriodo, setDateTimePeriodo] = useState(null);
    const [errorPeriodo, setErrorPeriodo] = useState(false);
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitExcedentesUG (e) {
        e.preventDefault();

        const periodo = dateTimePeriodo ? formatShortMonthParam(dateTimePeriodo) : '';
        if (!periodo) {
            setErrorPeriodo(true);
            return;
        }

        setErrorPeriodo(false);
        setIsSubmit(true);

        const body = JSON.stringify({
            periodo
        });

        try {
            const response = await fetchFlask('excedentesUG', body);
            setStatus(response.status);
            setOpenAlerta(true);
            if (response.status !== 'error') {
                downloadCsvContent(`excedentes_ug_${periodo}.csv`, response);

                setDateTimePeriodo(null);
                setMessage('Arquivo gerado com sucesso!');
            } else {
                setMessage('Erro ao gerar csv!');
            }
        } finally {
            setIsSubmit(false);
        }
    };

    const periodoLabel = formatMonthYearLabelPtBr(dateTimePeriodo);
    const completedFields = [dateTimePeriodo].filter(Boolean).length;

    return (
        <Box className='mainBox generator-surplus-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Excedentes UG
            </PageHeader>

            <form action='' method='POST' id='formExcedentesUG' onSubmit={submitExcedentesUG} className='generator-surplus-layout'>
                <Box className='generator-surplus-workspace'>
                    <Box className='generator-surplus-intro'>
                        <Box>
                            <h2>Exportação de excedentes por competência</h2>
                        </Box>
                    </Box>

                    <Box className='generator-surplus-panel'>
                        <Box className='generator-surplus-section-heading'>
                            <CalendarMonthRoundedIcon />
                            <Box>
                                <span>Etapa única</span>
                                <strong>Competência das faturas</strong>
                            </Box>
                        </Box>

                        <Box className='generator-surplus-date-strip'>
                            <ShowChartRoundedIcon />
                            <LocalizationProvider adapterLocale={pt} dateAdapter={AdapterDateFns}>
                                <FormControl className='generator-surplus-date-control'>
                                    <DatePicker
                                        id='data'
                                        label='Período'
                                        views={['month', 'year']}
                                        openTo='month'
                                        minDate={new Date('2023-01-01')}
                                        maxDate={new Date()}
                                        value={dateTimePeriodo}
                                        onChange={(value) => setDateTimePeriodo(value)}
                                        slotProps={{
                                            openPickerButton: {
                                                color: 'primary'
                                            }
                                        }}
                                    />
                                    {errorPeriodo && (
                                        <Typography variant='caption' className='generator-surplus-error-text'>
                                            Por favor selecione uma data.
                                        </Typography>
                                    )}
                                </FormControl>
                            </LocalizationProvider>
                        </Box>
                    </Box>
                </Box>

                <Box className='generator-surplus-summary'>
                    <Box className='generator-surplus-summary-header'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão da exportação</strong>
                        </Box>
                    </Box>

                    <Box className='generator-surplus-summary-list'>
                        <Box>
                            <span>Competência</span>
                            <strong className={!dateTimePeriodo ? 'is-empty' : undefined}>{periodoLabel}</strong>
                        </Box>
                        <Box>
                            <span>Arquivo</span>
                            <strong>CSV de excedentes UG</strong>
                        </Box>
                    </Box>

                    <Box className='generator-surplus-attention'>
                        <RuleRoundedIcon />
                        <p>
                            Confirme a competência antes de gerar o CSV. O arquivo será baixado automaticamente após o processamento.
                        </p>
                    </Box>

                    <Box className='generator-surplus-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>{completedFields}/1 preenchido</strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} startIcon={<DownloadRoundedIcon />}>
                        Gerar CSV
                    </SubmitButton>
                </Box>
            </form>
        </Box>
    );
};

export default ExcedentesUG;
